
import SvgIcons from "@/components/SvgIcons";
import LoadingProgressBar from "./LoadingProgressBar";
import LoadingImage from "./LoadingImage";
import { getRandomNumber, secondsToHmsVerbose } from "@/helpers/helperFunctions";
import Link from "next/link";
import Input, { Select, TextArea } from "react-lite-float-inputs";
import {
    MySkillsOnDatabases,
    MySkillsOnFrameworksAndLibraries,
    MySkillsOnOtherTechnologies,
    MySkillsOnProgramming,
    MySkillsOnWebTechnologies,
} from "@/components/Skills";
import { TrainingModel } from "@/db/schema";
import { trainingTypeContextMap, TrainingTypes } from "@/app/skills-and-trainings/item";
import AnimatedTextWriter from "react-animated-text-writer";
import Moment from "moment";

const { LinkExternalIcon, WorkIcon, CVIcon } = SvgIcons();


export const SkeletonHomePage = () => {
    return (
        <div className="homePage">
            <div className="about">
                <h2>Abdullah Ibne Alam</h2>
                <h3>Crafting Innovative Solutions through Code</h3>
                <div className="prompt">
                    <div className="about-me-summary radial-anim-border">
                        <div className='max-w-[900] mx-auto'>
                            {/* <AnimatedTextWriter delay={50} startDelay={1000} content={', mobile app development, Process Automation and Internet of Things (IoT) solutions.'} prefix="Innovative software developer proficient in crafting full-stack applications" suffix="" displayCodeWrapper={false} displayCursorEnd={false} cursorColor="#999" /> */}
                            Senior Full-Stack Engineer and Solution Architect
                            <ul>
                                <AnimatedTextWriter delay={50} startDelay={500} content={` (React, Next.js, Vue.js)`} prefix={`<li><b>Full-Stack Application Development:</b><br /><div style="margin: 0 0 .5em; font-size: 0.6em">Expert in architecting scalable web applications across modern ecosystems, including Backend (Node.js, NestJS, Laravel, Spring Boot, FastAPI) and Frontend`} suffix={`</div></li>`} displayCodeWrapper={false} displayCursorEnd={false} cursorColor='#666' />
                                <AnimatedTextWriter delay={100} startDelay={600} content={` and Progressive Web Apps <b>(PWA)</b>`} prefix={`<li><b>Mobile & Cross-Platform Development:</b><br /><div style="margin: 0 0 .5em; font-size: 0.6em">Proven expertise in building high-performance mobile applications using <b>Flutter</b>`} suffix={`</div></li>`} displayCodeWrapper={false} displayCursorEnd={false} cursorColor='#666' />
                                <AnimatedTextWriter delay={80} startDelay={500} content={``} prefix={`<li><b>Internet of Things (IoT):</b><br /><div style="margin: 0 0 .5em; font-size: 0.6em">Specialized in IoT solutions, real-time data streaming, and machine-to-machine communication using <b>MQTT</b> protocols`} suffix={`</div></li>`} displayCodeWrapper={false} displayCursorEnd={false} cursorColor='#666' />
                                <AnimatedTextWriter delay={50} startDelay={200} content={``} prefix={`<li><b>Cloud & DevOps (SRE):</b><br /><div style="margin: 0 0 .5em; font-size: 0.6em">AWS (EC2, S3, IAM, Serverless), Kubernetes, Docker, Docker Compose, CI/CD (GitHub Actions), Grafana, Prometheus`} suffix={`</div></li>`} displayCodeWrapper={false} displayCursorEnd={false} cursorColor='#666' />
                            </ul>
                        </div>
                        <div className="absolute right-4 bottom-4 flex flex-row">
                            <Link href="/cv" className="button flex items-center gap-4" prefetch={true} >
                                <CVIcon width='32px' height='32px' style={{ margin: '-10px' }} />
                                View My CV
                            </Link>
                            <Link href="/work-with-me" className="button work-with-me" prefetch={true} >
                                <WorkIcon width='32px' height='32px' style={{ margin: '-10px' }} />
                                Work with Me
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="skillsIconsContainer mb-0!">
                    <div className="skillIconContainerFieldset scooped">
                        <h6>Accomplishments</h6>
                        <div className="grid grid-cols-12 gap-2 ">
                            <div className="col-span-12 lg:col-span-12 px-6 pb-4 prompt">
                                <LoadingProgressBar initial={getRandomNumber(0, 60)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="skillsIconsContainer">
                    <div className="grid grid-cols-12 gap-2">
                        <div className="col-span-12 lg:col-span-12">
                            <MySkillsOnProgramming onlyHighlights={true} />
                        </div>
                        <div className="col-span-12 md:col-span-7">
                            <MySkillsOnFrameworksAndLibraries onlyHighlights={true} />
                        </div>
                         <div className="col-span-12 md:col-span-5">
                            <MySkillsOnWebTechnologies onlyHighlights={true} />
                        </div>
                        <div className="col-span-12 md:col-span-5">
                            <MySkillsOnDatabases onlyHighlights={true} />
                        </div>
                        <div className="col-span-12 md:col-span-7">
                            <MySkillsOnOtherTechnologies onlyHighlights={true} />
                        </div>
                        <div className="col-span-12 lg:col-span-12">
                            <fieldset className="skillIconContainerFieldset">
                                <legend>And more...</legend>
                                <div className="px-8 pt-3">
                                    <LoadingProgressBar initial={getRandomNumber(0, 60)} />
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const SkeletonProjectItems = ({ n = 20 }: { n?: number }) => {
    return (
        <>
            {Array.from({ length: n }).map((_, index) => (
                <Link href="" key={index}  className='projectItemLink'>
                    <div className="projectItem" style={{ position: 'relative' }} >
                        <div>
                            <div className="bgImage">
                                <LoadingImage />
                            </div>
                            <h1>  </h1>
                            <p>  </p>
                        </div>
                        <LoadingProgressBar initial={getRandomNumber(0, 60)} />
                    </div>
                </Link>
            ))}
        </>
    );
};

export const SkeletonProjectItemsGlobal = ({ n = 20 }: { n?: number }) => {
    return (
        <div className="projects">
            <div className="projectList">
                <SkeletonProjectItems n={n} />
            </div>
        </div>
    );
}

export const SkeletonProjectItem = () => {
    return (
        <div className="project px-4 md:px-6!">
            <h1 className="projectHeadContainer skeleton-loading-container">&nbsp;</h1>
            <div className="projectDetails w-full text-[0.8em] sm:text-[0.9em] md:text-[1em] transition-all duration-300">
                <div className="description h-20 skeleton-loading-container"></div>
                 <div className='flex flex-col sm:flex-row justify-between gap-4 w-full pb-6 mt-4 transition-all duration-300'>
                    <div>
                        <h3 className='mt-0!'>Technology:</h3>
                        <div className="description h-5 skeleton-loading-container"></div>
                    </div>
                    <div>
                        <h3 className='mt-0!'>Versions:</h3>
                        <div className="description h-5 skeleton-loading-container"></div>
                    </div>
                </div>
                <LoadingProgressBar initial={getRandomNumber(0, 60)} />
                <LoadingImage height="200px" />
            </div>
        </div>
    );
};

export const SkeletonExperienceItems = ({ n = 5 }: { n?: number }) => {
    return (
        <div className="vertical-timeline vertical-timeline--animate vertical-timeline--two-columns">
            {Array.from({ length: n }).map((_, index) => (
                <div key={index} className="vertical-timeline-element--education vertical-timeline-element" >
                    <span className="vertical-timeline-element-icon bounce-in">
                        <WorkIcon />
                    </span>
                    <div className="vertical-timeline-element-content bounce-in">
                        <div className="vertical-timeline-element-content-arrow"></div>
                        <h3 className="vertical-timeline-element-title experienceItemContainer skeleton-loading-container"> &nbsp; </h3>

                        <h4 className="organization w-1/4 bg-[#6663]">&nbsp;</h4>
                        <div className="vertical-timeline-element-date">
                            &nbsp; &nbsp;
                        </div>
                        <div>
                            <h4 className="organization w-1/3 skeleton-loading-container">
                                &nbsp;
                            </h4>
                        </div>
                        <span className="vertical-timeline-element-date"></span>
                        <LoadingProgressBar initial={getRandomNumber(0, 60)} />
                    </div>
                </div>
            ))}
        </div>
    );
}

export const SkeletonExperienceItemsGlobal = ({ n = 20 }: { n?: number }) => {
    return (
        <div className="experience">
            <h1>Experience</h1>
            <div className="vertical-timeline vertical-timeline--animate vertical-timeline--two-columns">
                <SkeletonExperienceItems n={n} />
            </div>
        </div>
    );
}

export const SkeletonExperienceItemDetails = () => {
    return (
        <div className="experience">
            <div className="detailContainer">
                <h1>Experience</h1>
                <div className="vertical-timeline-element-content experienceItemDetailsContainer skeleton-loading-container" style={{ margin: 0, padding: 20 }}>
                    <h3 className="vertical-timeline-element-title skeleton-loading-container">&nbsp;</h3>
                    <div className="highlight w-1/4 bg-[#6663]">&nbsp;</div>
                    <div className="details h-80 skeleton-loading-container"></div>
                    <LoadingProgressBar initial={getRandomNumber(0, 60)} />
                </div>
            </div>
        </div>
    );
}

export const SkeletonSkillsAndTrainings = () => {
    return (
        <div className="skillsContainer max-w-350 mx-auto my-5 px-6 py-6 bg-(--card-bg-color) rounded-xl shadow-lg">
            <h1 className="text-center text-3xl font-bold mb-6 mt-0 text-white">Skills</h1>
            <MySkillsOnProgramming />
            <MySkillsOnFrameworksAndLibraries />
            <MySkillsOnWebTechnologies />
            <MySkillsOnDatabases />
            <MySkillsOnOtherTechnologies />

            <h1 className="text-center text-3xl font-bold mb-12 mt-15 text-white">Publications, Trainings and Certifications</h1>
            <SkeletonSkillsAndTrainingsItems />
        </div>
    );
}

export const SkeletonSkillsAndTrainingsItem = ({ item }: { item?: TrainingModel }) => {
    let date = item ? Moment(item.edate).format('MMMM D, Y') : '';
    const duration = item ? secondsToHmsVerbose((item.duration ?? 0) * 60, 'hour', 'min') : '';

    if (item) {
        if (item.displayonlyyear === 1) {
            date = Moment(item.edate).format('Y');
        } else if (item.hidedate === 1) {
            date = Moment(item.edate).format('MMMM Y');
        }
    }

    return (
        <div className="trainingItem">
            <h3 className="skeleton-loading-container">
                {item ?
                <>
                    {item.title}
                    {item.certificate_url && (
                        <a href={item.certificate_url} target="_blank" rel="noopener noreferrer" style={{ marginLeft: '8px' }}>
                            <LinkExternalIcon width="20px" height="20px" />
                        </a>
                    )}
                </> : <>&nbsp;</>
                }
            </h3>
            <div>
                <h4 className="skeleton-loading-container">
                    {item ? item.institution : <>&nbsp;</>}
                </h4>
                {item ? <p>
                    <span>
                        {trainingTypeContextMap[item.type as TrainingTypes].prefix ? <b>{trainingTypeContextMap[item.type as TrainingTypes].prefix}: </b> : ''}
                        {date}
                        {trainingTypeContextMap[item.type as TrainingTypes].text && <span style={{ color: trainingTypeContextMap[item.type as TrainingTypes].color }}> ({trainingTypeContextMap[item.type as TrainingTypes].text})</span>}
                    </span>
                </p> :
                <p>
                    <span className="skeleton-loading-container">&nbsp;</span>
                    <span className="skeleton-loading-container">&nbsp;</span>
                </p>
                }
            </div>
            <LoadingProgressBar initial={getRandomNumber(0, 60)} />
        </div>
    );
}

export const SkeletonSkillsAndTrainingsItems = ({ n = 10 }: { n?: number }) => {
    const items: TrainingModel[] = [
        {
            id: 1,
            title: "Application of Wind Resource Assessment (WEA) Tool: A case study in Kuakata, Bangladesh",
            uri: null,
            institution: "https://www.ijrer.org",
            org: '',
            type: "Publication",
            certificate_url: "https://www.ijrer.org/index.php/ijrer/article/view/63",
            images: [],
            og_images: [],
            description: "",
            sdate: null,
            edate: new Date("2011-06-07T00:00:00.000Z"),
            duration: null,
            currentlyworking: 0,
            displayonlyyear: 0,
            hidedate: 0,
            active: 1
        },
        {
            id: 74,
            title: "Docker Foundations Professional Certificate",
            uri: null,
            institution: "LinkedIn Learning & docker",
            org: "docker",
            type: "Certification",
            certificate_url: "https://www.linkedin.com/learning/certificates/25eb614935d4c994a61a577fbc8bf15e3d3799104c8eb723bf508f71a02f34f9",
            images: [],
            og_images: [],
            description: '',
            sdate: null,
            edate: new Date("2026-02-13T00:00:00.000Z"),
            duration: 222,
            currentlyworking: 0,
            displayonlyyear: 0,
            hidedate: 0,
            active: 1
        }
    ];
    return (
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-y-5 gap-x-6">
            {items.map((item, index) => (
                <SkeletonSkillsAndTrainingsItem key={index} item={item} />
            ))}
            {Array.from({ length: n }).map((_, index) => (
                <SkeletonSkillsAndTrainingsItem key={index} />
            ))}
        </div>
    );
}

export const SkeletonGameItems = ({ n = 20 }: { n?: number }) => {
    return (
        <>
        {Array.from({ length: n }).map((_, index) => (
            <Link href='#' key={index}>
                <div className="gameItem">
                    <div className="bgImage">
                        <LoadingImage />
                    </div>
                    <h1> &nbsp; </h1>

                    <LoadingProgressBar initial={getRandomNumber(0, 60)} />
                </div>
            </Link>
        ))}
        </>
    );
}

export const SkeletonGamesItemsGlobal = ({ n = 20 }: { n?: number }) => {
    return (
        <div className="games">
            <div className="gameList">
                <SkeletonGameItems n={n} />
            </div>
        </div>
    );
}


export const SkeletonBlogPostItems = ({ n = 20 }: { n?: number }) => {
    return (
        <>
            {Array.from({ length: n }).map((_, index) => (
                <Link href="" key={index}  className='px-6 pt-2 pb-6 bg-slate-800/30 rounded-xl border border-slate-800 cursor-pointer flex flex-col gap-4 md:block transition-all duration-300 hover:bg-slate-700/50'>
                    <div className="postItem group relative">
                        <h3 className="text-xl font-bold mt-3 mb-4 skeleton-loading-container">Title</h3>
                        <p className="text-sm text-gray-500 mb-2 -mt-4 skeleton-loading-container"><b>Author:</b>  </p>
                        <div className="details h-15 skeleton-loading-container"></div>
                        <p className="text-lg text-slate-400 mb-4 skeleton-loading-container"> </p>
                        <div className="flex flex-wrap gap-4 mb-2">
                            <span className="inline-block bg-slate-200 dark:bg-slate-700 text-slate-800 dark:text-slate-200 px-3 py-1 rounded-full text-sm">Tags</span>
                        </div>
                    </div>
                    <LoadingProgressBar initial={getRandomNumber(0, 60)} />
                </Link>
            ))}
        </>
    );
};

export const SkeletonBlogPostItem = () => {
    return (
        <div className="project px-4 md:px-6!">
            <h1 className="projectHeadContainer skeleton-loading-container">&nbsp;</h1>
            <div className="projectDetails w-full text-[0.8em] sm:text-[0.9em] md:text-[1em] transition-all duration-300 pb-8">
                <div className="description h-80 skeleton-loading-container"></div>
                 <div className='flex flex-col sm:flex-row justify-between gap-4 w-full pb-6 mt-4 transition-all duration-300'>
                    <div>
                        <h3 className='mt-0!'>Tags:</h3>
                        <div className="description h-5 skeleton-loading-container"></div>
                    </div>
                </div>
                <LoadingProgressBar initial={getRandomNumber(0, 60)} />
            </div>
        </div>
    );
};

export const SkeletonBlogPostItemsGlobal = ({ n = 20 }: { n?: number }) => {
    return (
        <section className="max-w-7xl mx-auto pb-6 md:pb-10 px-0 md:px-0 grid gap-2 md:gap-4 lg:gap-6">
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mt-0 mb-1 transition-all duration-300">Blog</h1>
            <div className="flex flex-col gap-2">
                <SkeletonBlogPostItems n={n} />
            </div>
        </section>
    );
}

export const WorkWithMeSkeleton = () => {
    return (
        <div className="max-w-lg mx-auto my-5 px-10 py-6 bg-(--card-bg-color) rounded-xl shadow-lg">
            <h1 className="text-center text-3xl font-bold mb-6 mt-0 text-white">Work with Me</h1>
                <form  className="flex flex-col gap-4">
                <Input
                    type="text"
                    name="name"
                    label="Name"
                    value={''}
                    readOnly={true}
                    placeholder="Your name"
                    required
                />
                <Input
                    type="email"
                    name="email"
                    label="Email"
                    value={''}
                    readOnly={true}
                    placeholder="Your email"
                    required
                />
                <Select name="topic" label="Topic" required defaultValue={''} disabled={true}>

                </Select>
                <Input
                    type="text"
                    name="url"
                    label="URL"
                    value={''}
                    readOnly={true}
                    placeholder="Reference URL (optional)"
                />
                <Input
                    type="text"
                    name="budget"
                    label="Budget"
                    value={''}
                    readOnly={true}
                    placeholder="Budget (optional)"
                />
                <TextArea
                    name="message"
                    value={''}
                    readOnly={true}
                    label="Message"
                    placeholder="Tell me about your project..."
                    rows={5}
                    required
                />
                <button
                    type="submit"
                    disabled={true}
                    className={`mt-2 py-3 rounded-md font-semibold text-lg transition-colors bg-(--input-border-color) text-gray-400 cursor-not-allowed! '}`}
                >
                    Send Message
                </button>
            </form>
        </div>
    );
}

const Skeletons = {
    SkeletonProjectItem,
    SkeletonProjectItems,
    SkeletonProjectItemsGlobal,
    SkeletonExperienceItems,
    SkeletonExperienceItemsGlobal,
    SkeletonExperienceItemDetails,
    SkeletonSkillsAndTrainings,
    SkeletonGameItems,
    SkeletonGamesItemsGlobal,
    SkeletonBlogPostItems,
    SkeletonBlogPostItemsGlobal,
    WorkWithMeSkeleton
}

export default Skeletons;